import { render } from "./cities-list.vue?vue&type=template&id=380db5ba"
import script from "./cities-list.vue?vue&type=script&lang=js"
export * from "./cities-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__